export const softwarePublicCopy = {
  it: {
    section: "Sviluppo software",
    intro:
      "Applicazioni Enkey, progettate per rendere più semplice il lavoro di ogni giorno. Strumenti concreti, versioni ufficiali e assistenza diretta.",
    catalogue: "Le nostre applicazioni",
    view: "Scopri l’applicazione",
    compatibility: "Windows 10 e Windows 11 · 64 bit (x64)",
    requirements: "Compatibilità e requisiti",
    install: "Come iniziare",
    privacyHeadline: "I dati della diagnosi restano sul PC",
    privacyBody:
      "Per l’attivazione invii a Enkey nome o entità, email, telefono, località e nazione. Le statistiche d’uso sono facoltative, inizialmente spente, non anonime e revocabili.",
    offlineHeadline: "Anche sui PC senza Internet",
    offlineBody:
      "Un PC collegato prepara la licenza per il destinatario offline. Il PC senza rete importa il file e verifica la licenza; i dati della diagnosi non vengono trasferiti.",
    features: "Cosa puoi fare",
    downloadTitle: "Scarica Enkey PCDiag per Windows",
    checksum: "Verifica del file",
    signature:
      "Firmato digitalmente da ENKEY S.N.C. DI COSSU NICOLA E DIANA SABRINA",
    screenshots: "Dentro l’applicazione",
    screenshotNote:
      "Schermata dimostrativa della versione 3.0.0; non rappresenta una promessa di risultati.",
    installationSteps: [
      "Scarica lo ZIP originale ed estrai tutti i file.",
      "Apri EnkeyPCDiag.exe. I permessi di amministratore permettono controlli e correzioni più completi.",
      "Leggi i termini, compila la registrazione gratuita e apri l’email con la key.",
      "Premi Conferma la verifica nella pagina Enkey, poi inserisci la key nell’app.",
    ],
    requirementsItems: [
      "Windows 10 o Windows 11 a 64 bit (x64). La build disponibile non è una versione per Windows a 32 bit o ARM.",
      "Microsoft Edge o Google Chrome; nessuna estensione da installare.",
      "Circa 15 MB di spazio, oltre ai report. Connessione necessaria per registrazione e controlli online; attivazione offline tramite un altro PC.",
      "Aggiornamenti programmi: Windows 10 versione 1809 o successiva, oppure Windows 11, con winget e Internet.",
      "Test GPU: Edge/Chrome 113 o successivo, accelerazione hardware e driver aggiornati. Alcune misure dipendono dal produttore.",
    ],
    legalLabel: "Documenti dell’applicazione",
    legalLanguage: "Testi legali in italiano",
    featureTexts: [
      [
        "Diagnosi chiara",
        "Controlla hardware, sicurezza, stabilità, avvio, aggiornamenti e spazio. Le spiegazioni aiutano a scegliere cosa fare.",
      ],
      [
        "Riparazione guidata",
        "Le correzioni vengono applicate con la tua conferma. Punto di ripristino, verifiche e ripresa dopo il riavvio quando previsti.",
      ],
      [
        "Test e report",
        "Test di processore, RAM, scheda video e dischi, lettura delle schermate blu e report da condividere con un tecnico.",
      ],
    ],
  },
  en: {
    section: "Software development",
    intro:
      "Enkey applications designed to make everyday work simpler. Practical tools, official releases and direct support.",
    catalogue: "Our applications",
    view: "Explore the application",
    compatibility: "Windows 10 and Windows 11 · 64-bit (x64)",
    requirements: "Compatibility and requirements",
    install: "Getting started",
    privacyHeadline: "Diagnostic data stay on your PC",
    privacyBody:
      "Activation sends your name or organisation, email, phone, location and country to Enkey. Usage statistics are optional, off by default, identifiable and revocable.",
    offlineHeadline: "For PCs without Internet too",
    offlineBody:
      "A connected PC prepares the licence for the offline recipient. The offline PC imports and verifies the file; diagnostic data are not transferred.",
    features: "What you can do",
    downloadTitle: "Download Enkey PCDiag for Windows",
    checksum: "File verification",
    signature:
      "Digitally signed by ENKEY S.N.C. DI COSSU NICOLA E DIANA SABRINA",
    screenshots: "Inside the application",
    screenshotNote:
      "Demonstration screenshot of version 3.0.0; results are not guaranteed.",
    installationSteps: [
      "Download the original ZIP and extract all files.",
      "Open EnkeyPCDiag.exe. Administrator rights enable more complete checks and repairs.",
      "Read the terms, complete free registration and open the email containing your key.",
      "Confirm verification on the Enkey page, then enter the key in the app.",
    ],
    requirementsItems: [
      "Windows 10 or Windows 11, 64-bit x64. This release is not a native 32-bit or ARM build.",
      "Microsoft Edge or Google Chrome; no extension required.",
      "About 15 MB plus reports. Internet is needed for registration and online checks; offline activation uses another PC.",
      "Application updates: Windows 10 version 1809 or later, or Windows 11, with winget and Internet.",
      "GPU tests: Edge/Chrome 113 or later, hardware acceleration and updated drivers. Some readings depend on the vendor.",
    ],
    legalLabel: "Application documents",
    legalLanguage: "Legal texts in Italian",
    featureTexts: [
      [
        "Clear diagnostics",
        "Check hardware, security, stability, startup, updates and disk space. Plain explanations help you decide.",
      ],
      [
        "Guided repairs",
        "Changes require your confirmation. Restore points, verification and resuming after a reboot when supported.",
      ],
      [
        "Tests and reports",
        "CPU, RAM, GPU and disk tests, blue screen analysis and reports to share with a technician.",
      ],
    ],
  },
  es: {
    section: "Desarrollo de software",
    intro:
      "Aplicaciones Enkey para simplificar el trabajo diario. Herramientas prácticas, versiones oficiales y asistencia directa.",
    catalogue: "Nuestras aplicaciones",
    view: "Descubrir la aplicación",
    compatibility: "Windows 10 y Windows 11 · 64 bits (x64)",
    requirements: "Compatibilidad y requisitos",
    install: "Primeros pasos",
    privacyHeadline: "Los datos del diagnóstico permanecen en tu PC",
    privacyBody:
      "La activación envía a Enkey nombre o entidad, email, teléfono, localidad y país. Las estadísticas son opcionales, inicialmente desactivadas, identificables y revocables.",
    offlineHeadline: "También para PC sin Internet",
    offlineBody:
      "Un PC conectado prepara la licencia del destinatario sin red. El PC sin conexión importa y verifica el archivo; no se transfieren datos del diagnóstico.",
    features: "Qué puedes hacer",
    downloadTitle: "Descargar Enkey PCDiag para Windows",
    checksum: "Verificación del archivo",
    signature:
      "Firmado digitalmente por ENKEY S.N.C. DI COSSU NICOLA E DIANA SABRINA",
    screenshots: "Dentro de la aplicación",
    screenshotNote:
      "Captura de demostración de la versión 3.0.0; no garantiza resultados.",
    installationSteps: [
      "Descarga el ZIP original y extrae todos los archivos.",
      "Abre EnkeyPCDiag.exe. Los permisos de administrador permiten controles y reparaciones más completos.",
      "Lee las condiciones, completa el registro gratuito y abre el email con la key.",
      "Confirma la verificación en Enkey y escribe la key en la aplicación.",
    ],
    requirementsItems: [
      "Windows 10 o Windows 11 de 64 bits x64. No es una versión nativa para 32 bits o ARM.",
      "Microsoft Edge o Google Chrome, sin extensiones.",
      "Unos 15 MB más informes. Internet para registro y controles online; activación sin red mediante otro PC.",
      "Actualizaciones: Windows 10 versión 1809 o posterior, o Windows 11, winget e Internet.",
      "Test GPU: Edge/Chrome 113 o posterior, aceleración y controladores actualizados. Algunas medidas dependen del fabricante.",
    ],
    legalLabel: "Documentos de la aplicación",
    legalLanguage: "Textos legales en italiano",
    featureTexts: [
      [
        "Diagnóstico claro",
        "Hardware, seguridad, estabilidad, inicio, actualizaciones y espacio en disco.",
      ],
      [
        "Reparación guiada",
        "Cambios con tu confirmación, puntos de restauración y comprobaciones cuando corresponda.",
      ],
      [
        "Pruebas e informes",
        "Tests de CPU, RAM, GPU y discos, análisis de pantallas azules e informes para el técnico.",
      ],
    ],
  },
  fr: {
    section: "Développement logiciel",
    intro:
      "Des applications Enkey pour simplifier le travail quotidien. Outils pratiques, versions officielles et assistance directe.",
    catalogue: "Nos applications",
    view: "Découvrir l’application",
    compatibility: "Windows 10 et Windows 11 · 64 bits (x64)",
    requirements: "Compatibilité et prérequis",
    install: "Premiers pas",
    privacyHeadline: "Les données du diagnostic restent sur le PC",
    privacyBody:
      "L’activation transmet à Enkey nom ou organisme, email, téléphone, localité et pays. Les statistiques sont facultatives, désactivées au départ, identifiables et révocables.",
    offlineHeadline: "Aussi pour les PC sans Internet",
    offlineBody:
      "Un PC connecté prépare la licence du destinataire hors ligne. Le PC hors réseau importe et vérifie le fichier; les données du diagnostic ne sont pas transférées.",
    features: "Ce que vous pouvez faire",
    downloadTitle: "Télécharger Enkey PCDiag pour Windows",
    checksum: "Vérification du fichier",
    signature:
      "Signé numériquement par ENKEY S.N.C. DI COSSU NICOLA E DIANA SABRINA",
    screenshots: "Dans l’application",
    screenshotNote:
      "Capture de démonstration de la version 3.0.0; les résultats ne sont pas garantis.",
    installationSteps: [
      "Téléchargez le ZIP original et extrayez les fichiers.",
      "Ouvrez EnkeyPCDiag.exe. Les droits administrateur permettent des contrôles plus complets.",
      "Lisez les conditions, inscrivez-vous gratuitement et ouvrez l’email contenant la key.",
      "Confirmez la vérification sur Enkey puis saisissez la key dans l’application.",
    ],
    requirementsItems: [
      "Windows 10 ou Windows 11 x64, 64 bits. Pas de version native 32 bits ou ARM.",
      "Microsoft Edge ou Google Chrome, sans extension.",
      "Environ 15 Mo plus les rapports. Internet pour inscription et contrôles; activation hors ligne via un autre PC.",
      "Mises à jour: Windows 10 version 1809 ou ultérieure, ou Windows 11, winget et Internet.",
      "Test GPU: Edge/Chrome 113 ou ultérieur, accélération matérielle et pilotes à jour. Certaines mesures dépendent du fabricant.",
    ],
    legalLabel: "Documents de l’application",
    legalLanguage: "Textes juridiques en italien",
    featureTexts: [
      [
        "Diagnostic clair",
        "Matériel, sécurité, stabilité, démarrage, mises à jour et espace disque.",
      ],
      [
        "Réparation guidée",
        "Modifications avec confirmation, points de restauration et vérification lorsque disponibles.",
      ],
      [
        "Tests et rapports",
        "Tests CPU, RAM, GPU et disques, analyse des écrans bleus et rapports pour le technicien.",
      ],
    ],
  },
  de: {
    section: "Softwareentwicklung",
    intro:
      "Enkey Anwendungen für einfachere tägliche Arbeit. Praktische Werkzeuge, offizielle Versionen und direkter Support.",
    catalogue: "Unsere Anwendungen",
    view: "Anwendung entdecken",
    compatibility: "Windows 10 und Windows 11 · 64 Bit (x64)",
    requirements: "Kompatibilität und Voraussetzungen",
    install: "Erste Schritte",
    privacyHeadline: "Diagnosedaten bleiben auf deinem PC",
    privacyBody:
      "Die Aktivierung sendet Name oder Organisation, E-Mail, Telefon, Ort und Land an Enkey. Nutzungsstatistiken sind freiwillig, zunächst aus, zuordenbar und widerrufbar.",
    offlineHeadline: "Auch für PCs ohne Internet",
    offlineBody:
      "Ein verbundener PC erstellt die Lizenz für den Offline-PC. Dieser importiert und prüft die Datei; Diagnosedaten werden nicht übertragen.",
    features: "Möglichkeiten",
    downloadTitle: "Enkey PCDiag für Windows herunterladen",
    checksum: "Datei überprüfen",
    signature:
      "Digital signiert von ENKEY S.N.C. DI COSSU NICOLA E DIANA SABRINA",
    screenshots: "In der Anwendung",
    screenshotNote:
      "Demonstration der Version 3.0.0; Ergebnisse sind nicht garantiert.",
    installationSteps: [
      "Original-ZIP herunterladen und alle Dateien entpacken.",
      "EnkeyPCDiag.exe öffnen. Administratorrechte ermöglichen umfassendere Prüfungen.",
      "Bedingungen lesen, kostenlos registrieren und die E-Mail mit der key öffnen.",
      "Verifizierung auf Enkey bestätigen und die key in der Anwendung eingeben.",
    ],
    requirementsItems: [
      "Windows 10 oder Windows 11, 64 Bit x64. Keine native 32-Bit- oder ARM-Version.",
      "Microsoft Edge oder Google Chrome, ohne Erweiterung.",
      "Etwa 15 MB plus Berichte. Internet für Registrierung und Online-Prüfungen; Offline-Aktivierung über einen anderen PC.",
      "Programmupdates: Windows 10 ab Version 1809 oder Windows 11, winget und Internet.",
      "GPU-Tests: Edge/Chrome ab113, Hardwarebeschleunigung und aktuelle Treiber. Einige Werte sind herstellerabhängig.",
    ],
    legalLabel: "Dokumente der Anwendung",
    legalLanguage: "Rechtstexte auf Italienisch",
    featureTexts: [
      [
        "Klare Diagnose",
        "Hardware, Sicherheit, Stabilität, Start, Updates und Speicherplatz.",
      ],
      [
        "Geführte Reparaturen",
        "Änderungen mit Bestätigung, Wiederherstellungspunkte und Überprüfung soweit verfügbar.",
      ],
      [
        "Tests und Berichte",
        "CPU-, RAM-, GPU- und Laufwerktests, Bluescreenanalyse und Berichte für Techniker.",
      ],
    ],
  },
} as const;
